import React from 'react';

import { Icon } from '../icons/Icon';

type QuestionAnswerFeedbackProps = {
  isCorrect: boolean;
  explanation?: string | null;
};

export const QuestionAnswerFeedback: React.FC<QuestionAnswerFeedbackProps> = ({
  isCorrect,
  explanation,
}) => {
  const normalizedExplanation = typeof explanation === 'string' ? explanation.trim() : '';

  return (
    <div
      className="space-y-2 text-foundation-base-darkbase-dark-500 w-full"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {isCorrect ? (
        <div className="flex flex-row items-center text-[1.1rem]">
          <Icon
            name="blackCircleCheckmark"
            size={52}
            className="pr-3"
            aria-hidden="true"
            focusable="false"
            data-testid="answer-feedback-icon"
          />
          Correct!
        </div>
      ) : (
        <div className="flex flex-row items-center text-[1.1rem]">
          <Icon
            name="blackCircleX"
            size={52}
            className="pr-3"
            aria-hidden="true"
            focusable="false"
            data-testid="answer-feedback-icon"
          />
          Incorrect...
        </div>
      )}
      {normalizedExplanation ? (
        <div className="text-[0.875rem]">{normalizedExplanation}</div>
      ) : null}
    </div>
  );
};
